import React, { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { StyleProvider, Tab, Tabs } from '@attentive-platform/stem-ui';

import IntakeTab from './IntakeTab';
import RecordsTab from './RecordsTab';
import CatalogTab from './CatalogTab';
import DetailView from './DetailView';
import IntakeDrawer from './IntakeDrawer';
import FillOnBehalfView from './FillOnBehalfView';
import { RootStyles as S } from './styles';

const SECTION_TABS = [
  { key: 'intake', label: 'Intake' },
  { key: 'records', label: 'Scope Records' },
  { key: 'catalog', label: 'Catalog' }
];

const ScopeConsole = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedId = searchParams.get('id') || null;
  const [tabIndex, setTabIndex] = useState(0);
  const [screen, setScreen] = useState('detail');
  const [intakeOpen, setIntakeOpen] = useState(false);
  const [refreshToken, setRefreshToken] = useState(0);

  const section = SECTION_TABS[tabIndex];

  const openRow = useCallback(
    id => {
      setSearchParams(
        prev => {
          const next = new URLSearchParams(prev);
          if (id) next.set('id', id);
          else next.delete('id');
          return next;
        },
        { replace: false }
      );
      setScreen('detail');
    },
    [setSearchParams]
  );

  const backToList = () => {
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev);
        next.delete('id');
        return next;
      },
      { replace: false }
    );
    setScreen('detail');
    setRefreshToken(t => t + 1);
    window.scrollTo({ top: 0 });
  };

  const renderPanel = () => {
    if (selectedId && screen === 'onBehalf') {
      return (
        <FillOnBehalfView
          recordId={selectedId}
          onBack={() => setScreen('detail')}
          onSubmit={() => setScreen('detail')}
        />
      );
    }
    if (selectedId) {
      return (
        <DetailView
          recordId={selectedId}
          fromSection={section.key}
          onBack={backToList}
          onFillOnBehalf={() => {
            setScreen('onBehalf');
            window.scrollTo({ top: 0 });
          }}
          onMutated={() => setRefreshToken(t => t + 1)}
        />
      );
    }
    switch (section.key) {
      case 'intake':
        return (
          <IntakeTab
            refreshToken={refreshToken}
            onOpenRow={openRow}
            onNewIntake={() => setIntakeOpen(true)}
            searchLocked={intakeOpen}
          />
        );
      case 'records':
        return <RecordsTab refreshToken={refreshToken} onOpenRow={openRow} />;
      case 'catalog':
        return <CatalogTab />;
      default:
        return null;
    }
  };

  return (
    <StyleProvider>
      <S.Page>
        {!(selectedId && screen === 'onBehalf') && (
          <S.TabsBar>
            <Tabs
              value={tabIndex}
              textColor='primary'
              indicatorColor='primary'
              onChange={(_, next) => {
                setTabIndex(next);
                setSearchParams(
                  prev => {
                    const p = new URLSearchParams(prev);
                    p.delete('id');
                    return p;
                  },
                  { replace: true }
                );
                setScreen('detail');
              }}>
              {SECTION_TABS.map(t => (
                <Tab key={t.key} label={t.label} className='p-2' />
              ))}
            </Tabs>
          </S.TabsBar>
        )}
        {renderPanel()}
        <IntakeDrawer
          open={intakeOpen}
          onClose={() => setIntakeOpen(false)}
          onSend={() => {
            setIntakeOpen(false);
            setRefreshToken(t => t + 1);
          }}
          onOpenExisting={id => {
            setIntakeOpen(false);
            openRow(id);
            window.scrollTo({ top: 0 });
          }}
        />
      </S.Page>
    </StyleProvider>
  );
};

export default ScopeConsole;
